var React = require('react');

function Telephone (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.5794 8.25333c-.9665 0-1.9015-.13333-2.7736-.37333-.275-.08-.5814-.02-.7936.16L8.77864 9.35333c-2.22357-.9-4.30571-2.6-5.41357-4.55333l1.53214-1.10667c.21215-.18666.275-.44666.18857-.68-.29071-.74-.44-1.53333-.44-2.35333 0-.36-.35357-.66-.77785-.66H1.14936C.72507 0 .214355.16.214355.66.214355 6.85333 6.28793 12 13.5794 12c.5578 0 .7778-.42.7778-.7867V8.91333c0-.36-.3536-.66-.7778-.66Z","fill":"currentColor"}));
}

Telephone.defaultProps = {"width":"15","height":"12","viewBox":"0 0 15 12","fill":"none"};

module.exports = Telephone;

Telephone.default = Telephone;
